import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
/* eslint-disable */
import { Component, Children } from 'react';
import PropTypes from 'prop-types';
import getContextProps from "./get-context-props";
import Cache from "./cache";
var childContextCache = new Cache();

/**
 * ConfigProvider
 * @propsExtends false
 */
var ConfigProvider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ConfigProvider, _Component);
  /**
   * 传入组件的 props 和 displayName，得到和 childContext 计算过的包含有 preifx/locale/pure 的对象，一般用于通过静态方法生成脱离组件树的组件
   * @param {Object} props 组件的 props
   * @param {String} displayName 组件的 displayName
   * @returns {Object} 新的 context props
   */
  ConfigProvider.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.locale !== prevState.locale) {
      return {
        locale: nextProps.locale
      };
    }
    return null;
  };
  function ConfigProvider() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    childContextCache.add(_assertThisInitialized(_this), Object.assign({}, childContextCache.get(_assertThisInitialized(_this), {}), _this.getChildContext()));
    _this.state = {
      locale: _this.props.locale
    };
    return _this;
  }
  var _proto = ConfigProvider.prototype;
  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
      prefix = _this$props.prefix,
      locale = _this$props.locale,
      defaultPropsConfig = _this$props.defaultPropsConfig,
      pure = _this$props.pure,
      warning = _this$props.warning,
      rtl = _this$props.rtl,
      device = _this$props.device,
      popupContainer = _this$props.popupContainer,
      errorBoundary = _this$props.errorBoundary;
    var _ref = this.context,
      nextPrefix = _ref.nextPrefix,
      nextDefaultPropsConfig = _ref.nextDefaultPropsConfig,
      nextLocale = _ref.nextLocale,
      nextPure = _ref.nextPure,
      nextRtl = _ref.nextRtl,
      nextWarning = _ref.nextWarning,
      nextDevice = _ref.nextDevice,
      nextPopupContainer = _ref.nextPopupContainer,
      nextErrorBoundary = _ref.nextErrorBoundary;
    return {
      nextPrefix: prefix || nextPrefix,
      nextDefaultPropsConfig: defaultPropsConfig || nextDefaultPropsConfig,
      nextLocale: locale || nextLocale,
      nextPure: typeof pure === 'boolean' ? pure : nextPure,
      nextRtl: typeof rtl === 'boolean' ? rtl : nextRtl,
      nextWarning: typeof warning === 'boolean' ? warning : nextWarning,
      nextDevice: device || nextDevice,
      nextPopupContainer: popupContainer || nextPopupContainer,
      nextErrorBoundary: errorBoundary || nextErrorBoundary
    };
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    childContextCache.add(this, Object.assign({}, childContextCache.get(this, {}), this.getChildContext()));
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    childContextCache.remove(this);
  };
  _proto.render = function render() {
    return Children.only(this.props.children);
  };
  return ConfigProvider;
}(Component); // export default polyfill(ConfigProvider);
ConfigProvider.defaultProps = {
  warning: true,
  errorBoundary: false
};
ConfigProvider.contextTypes = {
  nextPrefix: PropTypes.string,
  nextLocale: PropTypes.object,
  nextDefaultPropsConfig: PropTypes.object,
  nextPure: PropTypes.bool,
  nextRtl: PropTypes.bool,
  nextWarning: PropTypes.bool,
  nextDevice: PropTypes.oneOf(['tablet', 'desktop', 'phone']),
  nextPopupContainer: PropTypes.any,
  nextErrorBoundary: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
};
ConfigProvider.childContextTypes = {
  nextPrefix: PropTypes.string,
  nextLocale: PropTypes.object,
  nextDefaultPropsConfig: PropTypes.object,
  nextPure: PropTypes.bool,
  nextRtl: PropTypes.bool,
  nextWarning: PropTypes.bool,
  nextDevice: PropTypes.oneOf(['tablet', 'desktop', 'phone']),
  nextPopupContainer: PropTypes.any,
  nextErrorBoundary: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
};
ConfigProvider.getContextProps = function (props, displayName) {
  return getContextProps(props, childContextCache.root() || {}, displayName);
};
ConfigProvider.clearCache = function () {
  childContextCache.clear();
};
ConfigProvider.getContext = function () {
  var _ref2 = childContextCache.root() || {},
    nextPrefix = _ref2.nextPrefix,
    nextLocale = _ref2.nextLocale,
    nextDefaultPropsConfig = _ref2.nextDefaultPropsConfig,
    nextPure = _ref2.nextPure,
    nextRtl = _ref2.nextRtl,
    nextWarning = _ref2.nextWarning,
    nextDevice = _ref2.nextDevice,
    nextPopupContainer = _ref2.nextPopupContainer,
    nextErrorBoundary = _ref2.nextErrorBoundary;
  return {
    prefix: nextPrefix,
    locale: nextLocale,
    defaultPropsConfig: nextDefaultPropsConfig,
    pure: nextPure,
    rtl: nextRtl,
    warning: nextWarning,
    device: nextDevice,
    popupContainer: nextPopupContainer,
    errorBoundary: nextErrorBoundary
  };
};
export default ConfigProvider;